import React from 'react'
import { IProps } from './index'
import { GridContainer } from 'marketing-site/src/mvp/library/components/GridContainer'

export const CardsWithImage = ({
  title,
  eyebrow,
  subhead,
  backgroundColor = 'transparent',
  cta,
  cards,
  layout = '3-3',
  bodyAlignment = 'start',
}: IProps) => {
  return (
    <div className="cards-with-image" data-testid="cards-with-image">
      <GridContainer
        layout={layout}
        eyebrow={eyebrow}
        title={title}
        titleSize="heading-2"
        subhead={subhead}
        cta={cta}
        ctaPosition="below-header"
        bodyColumnGap="default"
        bodyRowGap="large"
        body={cards}
        bodyAlignment={bodyAlignment}
        backgroundColor={backgroundColor}
      />
    </div>
  )
}
